import React from 'react';
import { Modal, Button } from 'antd';
import './style.scss';

const AIDisclaimerModal = ({ visible, onClose }) => {

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      className="ai-disclaimer-modal"
      width={800}
      bodyStyle={{
        padding: '40px',
        maxHeight: '80vh',
        overflowY: 'auto',
      }}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
    >
      <div className="ai-disclaimer-content">
        <h2 className="disclaimer-title">Disclaimer – AI-Based Interviews and Assessments</h2>
        <div className="disclaimer-text">
          <p className="intro-text">
            This interview/assessment process is conducted using Artificial Intelligence (AI)–based tools for the purpose of evaluating candidates' or employees' skills, competencies, and/or role suitability. By participating, you acknowledge and agree that:
          </p>
          
          <ol className="disclaimer-list">
            <li>
              The responses, voice, facial expressions (in case of video interviews), and other interaction data may be processed using AI technologies to assess communication, analytical ability, behavioural traits, and other relevant parameters.
            </li>
            <li>
              All data collected during this process shall be used solely for recruitment, evaluation, or internal skill assessment purposes, in accordance with the organization's Data Privacy Policy and applicable data protection laws.
            </li>
            <li>
              The results generated by the AI system serve as an input to the overall evaluation process. Final decisions regarding hiring, performance evaluation, or internal movements are made by authorized human evaluators and not solely based on AI output.
            </li>
            <li>
              While reasonable care is taken to ensure accuracy, the AI system may have inherent limitations and may not always interpret responses or expressions perfectly. Participants are encouraged to communicate naturally and clearly.
            </li>
            <li>
              By proceeding, you consent to the use of AI-based tools for conducting and analyzing this interview/assessment, and to the storage and processing of your responses for the purposes stated above.
            </li>
            <li>
              All content, questions, and outputs of this interview/assessment are confidential and intended solely for internal use. Sharing, recording, or reproducing the process or materials is strictly prohibited.
            </li>
          </ol>

          <p className="contact-text">
            Any claim, query, or concern arising from or related to this AI-based interview/assessment process shall be addressed only to the email address{' '}
            <a href="mailto:bfdlhroperations@bajajfinservdirect.in" className="email-link">
              bfdlhroperations@bajajfinservdirect.in
            </a>
            {' '}and no other party shall be responsible or liable for the same.
          </p>
        </div>

        <div className="modal-footer">
          <Button type="primary" onClick={onClose} className="close-button">
            I Understand
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AIDisclaimerModal;

